__turbopack_context__.v({
  "agentInfoContainer": "PT3RiW_agentInfoContainer",
  "agentName": "PT3RiW_agentName",
  "agentNameContainer": "PT3RiW_agentNameContainer",
  "buttonsContainer": "PT3RiW_buttonsContainer",
  "columnContainer": "PT3RiW_columnContainer",
  "container": "PT3RiW_container",
  "copy": "PT3RiW_copy",
  "displayId": "PT3RiW_displayId",
  "headline": "PT3RiW_headline",
  "image": "PT3RiW_image",
  "imageContainer": "PT3RiW_imageContainer",
  "jobBadge": "PT3RiW_jobBadge",
  "jobTitle": "PT3RiW_jobTitle",
  "link": "PT3RiW_link",
  "mailButton": "PT3RiW_mailButton",
  "mailButtonEmbedded": "PT3RiW_mailButtonEmbedded",
  "mailButtonHasPhone": "PT3RiW_mailButtonHasPhone",
  "overline": "PT3RiW_overline",
  "phoneLink": "PT3RiW_phoneLink",
  "phoneNumber": "PT3RiW_phoneNumber",
  "phoneNumbersContainer": "PT3RiW_phoneNumbersContainer",
  "privateOfficeAdvisorBadge": "PT3RiW_privateOfficeAdvisorBadge",
  "privateOfficeAdvisorBadgeText": "PT3RiW_privateOfficeAdvisorBadgeText",
  "privateOfficeAdvisorBadgeTextContainer": "PT3RiW_privateOfficeAdvisorBadgeTextContainer",
  "privateOfficeContainer": "PT3RiW_privateOfficeContainer",
  "privateOfficeInnerContainer": "PT3RiW_privateOfficeInnerContainer",
  "privateOfficeOuterContainer": "PT3RiW_privateOfficeOuterContainer",
  "requestAccessButtonVisibilityWrapper": "PT3RiW_requestAccessButtonVisibilityWrapper",
  "requestAccessButtonWrapper": "PT3RiW_requestAccessButtonWrapper",
  "textContainer": "PT3RiW_textContainer",
});
